<template>
  <b-container fluid>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <row>
      <b-col>
          <b-tabs pills align="right">
            <b-tab title="Bloque / Emergencia" active @click="tipoReporte = 1"><b-card-text></b-card-text></b-tab>
            <b-tab title="BIP multiplicador" @click="tipoReporte = 2"><b-card-text></b-card-text></b-tab>
          </b-tabs>
      </b-col>
    </row>
    <div>
      <filtros-busqueda :empleados.sync="empleados"
                        @buscar="buscarDatosBloques"
                        :tipo-busqueda="tipoBusqueda"
                        :comisionesBloque="true"/>
      <b-button :disabled="!excel" @click="exportarExcel()" variant="info">Exportar Excel</b-button>
    </div>
    <div>
      <b-alert variant="success"
               show
      >
        <span style="margin-right: 20%;">Total a recibir: {{ totalPagoArecibir | moneda }} </span>
      </b-alert>
    </div>
    <b-row>
      <b-col>
        <b-table
            id="Pendientes"
            thead-tr-class="columnas"
            :items="datos"
            :fields="columnas"
            :per-page="$registrosPorPagina"
            :current-page="paginaActual"
            responsive
            stacked="md"
            class="parrafos"
            foot-clone
            no-footer-sorting
            foot-row-variant="secondary"
            show-empty
        >
          <template v-slot:cell(fechaCalculoFechaProgramada)="row">
            {{ row.item.fechaCalculoFechaProgramada|formatoFechaCorta }}
          </template>
          <template v-slot:cell(fechaPago)="row">
            {{ row.item.fechaPago|formatoFechaCorta }}
          </template>
          <template v-slot:cell(fechaTratamiento)="row">
            {{ row.item.fechaTratamiento|formatoFechaCorta }}
          </template>
          <template #foot()="row">
            {{ " " }}
          </template>
          <template #foot(ponderacionBloque)="row">
            {{ ponderacionBloqueSuma }} Tratamientos Realizados
          </template>

          <template #empty="scope">
            <b-col v-if="!loader">
              <b-alert v-if="datos.length === 0" variant="warning" show>No hay datos</b-alert>
            </b-col>
            <div align="center" v-if="loader">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
          </template>
        </b-table>

        <b-pagination
            v-if="datos !== undefined && datos.length > 10"
            align="center"
            v-model="paginaActual"
            :total-rows="datos.length"
            :per-page="$registrosPorPaginaTabla"
            aria-controls="tabla"
        ></b-pagination>

      </b-col>
    </b-row>
    <br/>
    <br/>
    <br/>
  </b-container>
</template>
<script>
import FiltrosBusqueda from "@/components/Compensaciones/FiltrosBusqueda";
import XLSX from 'xlsx';

export default {
  components: {FiltrosBusqueda},
  props: {
    empleados: Array
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      excel: false,
      loader: false,
      quincena: null,
      especialidad: null,
      idEmpleado: null,
      totalPagoArecibir: 0,
      datos: [],
      bloqueColum: [
        {key: "idComision", label: "ID Comision", sortable: true},
        {key: "fechaTratamiento", label: "Fecha Tratamiento", sortable: true},
        {key: "fechaCalculoFechaProgramada", label: "Fecha", sortable: true},
        {key: "fechaPago", label: "Fecha programada pago", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "idPaciente", label: "Id Paciente", sortable: true},
        {key: "paciente", label: "Paciente", sortable: true},
        {key: "diente", label: "OD", sortable: true},
        {key: "tratamientio", label: "Tratamiento", sortable: true},
        {key: "numeroSesion", label: "N° sesión", sortable: true},
        {key: "tipoComision", label: "Tipo BIP", sortable: true},
        {key: "monto", label: "Monto a pagar", sortable: true},
      ],
      bipColum: [
        {key: "idComision", label: "ID Comision", sortable: true},
        {key: "fechaTratamientoString", label: "Fecha Tratamiento", sortable: true},
        {key: "fechaCalculoFechaProgramadaString", label: "Fecha", sortable: true},
        {key: "fechaPagoString", label: "Fecha programada pago", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "idPaciente", label: "Id Paciente", sortable: true},
        {key: "paciente", label: "Paciente", sortable: true},
        {key: "diente", label: "OD", sortable: true},
        {key: "tratamientio", label: "Tratamiento", sortable: true},
        {key: "numeroSesion", label: "N° sesión", sortable: true},
        {key: "ponderacion", label: "Ponderación bloque", sortable: true},
        {key: "monto", label: "Monto a pagar por tx", sortable: true},

      ],
      columnas: [],
      paginaActual: 1,
      tipoBusqueda: "quincena",
      ponderacionBloqueSuma: 0.0,
      filtros: null,
      tipoReporte: null,
      url: null,
      multiplicador: false,
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.tipoReporte = 1;

    if (this.$localStorageService.can('Com_01_cambio')) {
      this.bloqueColum.push({key: "nombreDoctorComision", label: "Empleado", sortable: true});
      this.bipColum.push({key: "nombreDoctorComision", label: "Empleado", sortable: true});
    }
  },
  methods: {
    exportarExcel() {
      const fecha = this.$moment(new Date()).format('l')
      const newDate = fecha.split("/")
      var dia = newDate[0];
      var mes = newDate[1];
      var anio = newDate[2];


      let datosExcel = [];
      this.datos.forEach((element) => {
        let datos = {
          "Fecha": this.$moment(element.fechaCalculoFechaProgramada).format('DD/MM/YYYY'),
          "Clínica": element.clinica,
          "ID paciente": element.idPaciente.toString(),
          "Paciente": element.paciente,
          "OD": element.diente,
          "Tratamiento": element.tratamientio,
          "Sesión tratamiento": element.numeroSesion,
          "Monto a pagar": element.monto,
          "Id Sesión": element.idSesion,
          "Fecha de pago": this.$moment(element.fechaPago).format('DD/MM/YYYY'),
          "Tipo Comisión": element.tipoComision,
          "Ponderación bloque": element.ponderacionBloque
        }

        if (this.$localStorageService.can('Com_01_cambio')) {
          datos["Empleado"] = element.nombreDoctorComision;
        }

        datosExcel.push(datos);

      });

      datosExcel.push("");
      datosExcel.push({
        "Total pago a recibir": "$ " + this.totalPagoArecibir
      });
      let data = XLSX.utils.json_to_sheet(datosExcel)
      const workbook = XLSX.utils.book_new()
      const filename = 'productividad_' + dia + '_' + mes + '_' + anio;
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    buscarDatosBloques(filtro) {
      this.paginaActual = 1;
      this.excel = false;
      this.filtros = filtro;
      this.loader = true
      this.datos = [];
      this.totalPagoArecibir = 0.0;
      this.ponderacionBloqueSuma = 0;

      this.$http.post(this.$api + 'comisiones/comision_productividad/'+this.url, filtro).then(respuesta => {
        if (respuesta.data.data) {
          let datos = respuesta.data.data;
          this.totalPagoArecibir = datos.subTotal;
          this.datos = datos.tabla;


          this.datos.forEach(d => {
            this.ponderacionBloqueSuma += d.ponderacionBloque;
          })
          this.excel = true;
        }
      }).finally(() => {
        this.loader = false;
      })
    }
  },
  watch :{
    tipoReporte(){

      switch (this.tipoReporte){
        case 2 : {
          this.datos = []
          this.columnas = this.bipColum
          this.url = 'multiplicador'
          this.multiplicador = true;
          break
        }
        default :{
          this.datos = []
          this.columnas = this.bloqueColum
          this.url = 'bloque/emergencia'
          this.multiplicador = false;
          break
        }
      }
    }
  }
}
</script>
<style>
#h1 {
  text-align: center;
  font-size: 25px;
  color: rgb(80, 180, 220);
  font-weight: bold;
}

#tablaIzquierda {
  float: left;
  padding: 10px;
  width: 300px;
  margin: 20px;
}

#tablaDerecha {
  float: left;
  padding: 10px;
  width: 300px;
  margin: 20px;
  margin-left: 200px;
}
</style>